module.exports = __webpack_public_path__ + "img/serveContent2.c1626e37.png";